import React from "react";
import FixedExpensesContainer from "../../containers/FixedExpenses";

function FixedExpenses(props) {
  return <FixedExpensesContainer {...props} />;
}

export default FixedExpenses;
